
<div :class="mainClasses">
  <flash fixed></flash>
  <div :class="{'navbar-content': isNotOneStop}">
    <app-header v-if="isNotOneStop" :user="user" v-bind="headerAttrs">
      <template #body>
        <slot name="header"></slot>
      </template>
    </app-header>
    <slot name="secondary-header"></slot>
  </div>
  <slot></slot>

  <app-footer v-if="hasFooter && isNotOneStop">
    <template #body>
      <slot name="footer"></slot>
    </template>
  </app-footer>
</div>
